import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { getCurrentUser } from './services/auth'
import { createI18n } from 'vue-i18n'
import enMessages from '@/locales/en.json';
import hiMessages from '@/locales/hi.json';
import bnMessages from '@/locales/bn.json';
import teMessages from '@/locales/te.json';
import taMessages from '@/locales/ta.json';
import mrMessages from '@/locales/mr.json';
import guMessages from '@/locales/gu.json';
import knMessages from '@/locales/kn.json';
import mlMessages from '@/locales/ml.json';
import paMessages from '@/locales/pa.json';
import orMessages from '@/locales/or.json';
import urMessages from '@/locales/ur.json';

// Function to load all messages first
async function loadAllMessages() {
  const messages = {
    'en': enMessages,
    'hi': hiMessages,
    'bn': bnMessages,
    'te': teMessages,
    'ta': taMessages,
    'mr': mrMessages,
    'gu': guMessages,
    'kn': knMessages,
    'ml': mlMessages,
    'pa': paMessages,
    'or': orMessages,
    'ur': urMessages
  };
  
  console.log("Loaded all locale files from src/locales/");
  return messages;
}
// async function loadAllMessages() {
//   const locales = ['en', 'hi', 'bn', 'te', 'ta', 'mr', 'gu', 'kn', 'ml', 'pa', 'or', 'ur'];
//   const messages = {};
  
//   for (const localeCode of locales) {
//     console.log("localeCode => ", localeCode)
//     try {
//       const response = await fetch(`/locales/${localeCode}.json`);
//       console.log("response from locale files ", response);
//       if (response.ok) {
//         messages[localeCode] = await response.json();
//       }
//     } catch (error) {
//       messages[localeCode] = {}; // Empty fallback
//     }
//   }
  
//   return messages;
// }

// Initialize everything
async function initApp() {
  
  // Load all messages first
  const messages = await loadAllMessages();
    
  // Get preferred language
  const getPreferredLanguage = () => {
    if (typeof window !== 'undefined' && window.localStorage) {
      return localStorage.getItem('preferredLanguage') || 'english';
    }
    return 'english';
  };
  
  const getLocaleCode = (preferred) => {
    const localeMap = {
      'english': 'en',
      'hindi': 'hi',
      'bengali': 'bn',
      'telugu': 'te',
      'tamil': 'ta',
      'marathi': 'mr',
      'gujarati': 'gu',
      'kannada': 'kn',
      'malayalam': 'ml',
      'punjabi': 'pa',
      'odia': 'or',
      'urdu': 'ur',
    };
    return localeMap[preferred] || 'en';
  };
  
  const preferredLanguage = getPreferredLanguage();
  const locale = getLocaleCode(preferredLanguage);
  
  // Create i18n with all messages loaded
  const i18n = createI18n({
    legacy: false,
    locale: locale,
    fallbackLocale: 'en',
    messages: messages
  });
    
  // Create the app
  const app = createApp(App);
  
  app.config.errorHandler = (error, vm, info) => {
    console.error('Global error:', error);
    if (error.message && error.message.includes('500')) {
      router.push({
        path: '/server-error',
        query: { message: error.message }
      });
    }
  };
  
  // Use router and i18n
  app.use(router);
  app.use(i18n);
  
  // Provide i18n globally to all components
  app.provide('i18n', i18n);
  app.config.globalProperties.$i18n = i18n;
  
  // Expose i18n globally for utils/i18n.js
  window.__i18n = i18n;
    
  // Try to get current user if token exists
  getCurrentUser();
  
  // Small delay to ensure everything is ready
  setTimeout(() => {
    // Mount the app
    app.mount('#app');
  }, 100);
}

// Start the app
initApp();